import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { NotificationsState } from "./notifications.slice";

/** See @vv/teams-frontend/src/state/hooks.ts for why this is deliberately
 * local/narrow rather than importing @vv/state's RootState. */
interface NotificationsModuleState {
  notifications: NotificationsState;
}

type NotificationsModuleDispatch = ThunkDispatch<NotificationsModuleState, unknown, UnknownAction>;

export const useNotificationsDispatch = () => useDispatch<NotificationsModuleDispatch>();
export const useNotificationsSelector: TypedUseSelectorHook<NotificationsModuleState> = useSelector;
